import { FormControl, Select, MenuItem } from "@mui/material";
import * as T from "common/src/bindings/Translation2";

type Props = {
  set: number;
  setSet: (set: number) => void;
};

export default function TlSetSelect({ set, setSet }: Props) {
  return (
    <FormControl variant="standard">
      <Select
        variant="standard"
        className="w-[80px]"
        value={set}
        onChange={(e) => setSet(Number(e.target.value))}
      >
        <MenuItem value={150}>{T.common("Set #").replace("#", "15")}</MenuItem>
        <MenuItem value={140}>{T.common("Set #").replace("#", "14")}</MenuItem>
        <MenuItem value={130}>{T.common("Set #").replace("#", "13")}</MenuItem>
        <MenuItem value={120}>{T.common("Set #").replace("#", "12")}</MenuItem>
        <MenuItem value={110}>{T.common("Set #").replace("#", "11")}</MenuItem>
        <MenuItem value={10}>{T.common("Set #").replace("#", "10")}</MenuItem>
        <MenuItem value={95}>{T.common("Set #").replace("#", "9.5")}</MenuItem>
      </Select>
    </FormControl>
  );
}
